import { Typography, TypographyProps } from '@mui/material'

export default function HeaderPage(props: TypographyProps) {
  return (
    <Typography color="primary" variant="h1" {...props} sx={{ fontSize: (t) => t.typography.h2 }} />
  )
}
